import { render, staticRenderFns } from "./Pdtscan.vue?vue&type=template&id=140ed67c"
import script from "./Pdtscan.vue?vue&type=script&lang=js"
export * from "./Pdtscan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports